<template>
  <div>
    <div class="title">
      <div class="split" />
      当前享有多重保障，退款无忧
    </div>
    <div class="benefit-list">
      <div
        class="benefit-item"
        v-for="item in jyCardInfo.benefit_info_list"
        :key="item.id"
      >
        <div class="benefit-item-title">{{ item.show_title }}</div>
        <div class="benefit-item-value">{{ item.desc }}</div>
      </div>
    </div>
    <div class="content-desc">下次续费时间：{{ nextRenewalTime }}</div>
    <div class="btn" @click="handleDraw">立即领取</div>
    <div class="text-btn" @click="handleCancelDeduction">关闭自动续费</div>
    <CancelRenewalModal
      :show="showCancelRenewalModal"
      @close="showCancelRenewalModal = false"
    />
  </div>
</template>

<script>
import { defineComponent, ref, computed } from "@vue/composition-api";

import { useRouter, useRoute, useStore } from "@/components/use/base";

import CancelRenewalModal from "./CancelRenewalModal.vue";

export default defineComponent({
  components: {
    CancelRenewalModal,
  },
  props: {
    jyCardInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    const showCancelRenewalModal = ref(false);

    const nextRenewalTime = computed(() => {
      return store.state?.userInfo?.card_expiry_date?.[0];
    });

    const handleDraw = () => {
      router.replace(`/index?orderId=${route.query?.orderId}`);
    };

    const handleCancelDeduction = () => {
      showCancelRenewalModal.value = true;
    };

    return {
      handleDraw,
      handleCancelDeduction,
      showCancelRenewalModal,
      nextRenewalTime,
    };
  },
});
</script>


<style lang="less" scoped>
.title {
  display: flex;
  align-items: center;
  font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  line-height: 16px;
  margin-top: 24px;

  .split {
    width: 2px;
    height: 14px;
    background: #e4d1b4;
    border-radius: 1px;
    margin-right: 4px;
  }
}

.benefit-list {
  margin-top: 16px;

  display: flex;
  flex-wrap: wrap;
  gap: 5px;

  .benefit-item {
    width: 109px;
    height: 67px;
    background: #fff7f2;
    border-radius: 8px;
    border: 1px solid #fcc2c2;
    box-sizing: border-box;
    padding: 12px 10px;
  }

  .benefit-item-title {
    font-weight: 600;
    font-size: 14px;
    color: #ff8035;
    line-height: 20px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .benefit-item-value {
    font-weight: 400;
    font-size: 10px;
    color: #666666;
    line-height: 12px;
    margin-top: 4px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.content-desc {
  margin-top: 16px;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  line-height: 17px;
}

.btn {
  margin-top: 24px;
  background: linear-gradient(115deg, #4082e7 0%, #3254f2 100%);
  height: 40px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 17px;
  color: #ffffff;
  line-height: 40px;
  text-align: center;
}

.text-btn {
  margin-top: 12px;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  line-height: 17px;
  text-align: center;
}
</style>